var _rect, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForms2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "url(#pattern0)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "url(#pattern1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0217391)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0217391)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 46,
    height: 46,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAADj0lEQVR4nO3ZT6hUZRjH8Y86/gkFraVGiekiwSwUN9ZKbnDbCC1CfNqIixbXK0XhwkyMENNNiy60SSjqiYQUEUMKRW1jy1CDhAsaLiKJUBTiRmCL94wM1/TOzDl3LoE/GAbOnPOcL++f531+z8yKiDtYaPDalpmf9ftwS4HegitNEXWhI1hSJ0Cr+r6SmT/VpelWEfFX3RizmwCZCT0CH7QegQ9aj8AHrf8teGvqW+orIuZhJZZiERZjRUQ8heuZebfXmNMGHhHLERjGBszFBG4r4DswipsRcR7HcTQzb3cTv3HwiFiLfdiMcXyD93E5M3/ruK+F5ViPIXyEsYgYw6HM/PNh75kVEXfxQt1aJSIew0GM4DT2Z+YPPTw/H1uxR5mRtzPz82kFj4hnlKl+HG9k5rc1Ys3HLuzF19iemX9Pvq92VomINbiA3/F8HWjIzInM/AAvYRO+i4j7/EIt8Gqkz+A8XsnMP+rE61Rm/oiNeBrHqsx0T32DV2v6OC4i/ms66yozr+JlrMOhzt/qjPhBZU1vmQ7otjJzXNm0oxEx1L7eF3iV8kaUjdjY8niQMvN7HMbHVRrte8T34XTdjdijduNJvE4f4NWJuBn7G8WaQtXMfoI36W/EA+O9HC4N6jDWRsSafsCHlWN84MrMX/AzhnsCr3LpBpydDrAudQ4v9jriK5Uq73LjON3rIlb3Cr4UE51V3gzoKpb1Cr5IqadnUrexoF2PH+myLba4+syk5lKMxDbdNyBXYEdEtDLzn2kCm0pLcKvVS6u38oijinMZnxasqbUK13pd49dxU7FbM6X1uNQTeOXGzyseceCKiNmKuTjbz8l5HK9WFmvQ2oQncLIf8KPKzt7aKFJ3GsGpzLzRM3jV9xjDu4Mc9YhYp1SlB+i/Hj+kpKVdzWA9XBExRxmsE5l5gT7Bq2bNO9gbERuaQ3yg3sNq7GxfmFUnWkR8oWyYjZWxbVwR8Rq+UrztvXK6bl9lu/I345mIWFkz1n2qoL/Enk5oao54FXwhjikthK2Vsa0bc46yPPYo0B9Ovqc2ePWiecqGHVXs1e5+3X+VPcaUNb198ki31Qh4x0uHqpcuU4ztp5k55T/WHSfiiJLyTmBnZv76oGcaBa8gWkoL4S08p3jEc4pzuarU03OVdLpKqT3aJ+IpHGinvIepcfBOVQ3RYaWB+awyEwuqn2/hGi4pHvZkZt7oNva/P5Ef7bIzex4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms2);
export default __webpack_public_path__ + "static/media/forms2.873bc9946949841e5523f03ad5e2d42e.svg";
export { ForwardRef as ReactComponent };